var _path, _path2, _path3, _path4, _path5, _circle, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailSent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 72,
    viewBox: "0 0 96 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.16006C0 1.61052 0.447715 1.16504 1 1.16504H40.5452C41.0975 1.16504 41.5452 1.61052 41.5452 2.16006C41.5452 2.70959 41.0975 3.15507 40.5452 3.15507H1C0.447715 3.15507 0 2.70959 0 2.16006Z",
    fill: "#D8D7E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49023 9.24306C9.49023 8.69353 9.93795 8.24805 10.4902 8.24805H26.3083C26.8606 8.24805 27.3083 8.69353 27.3083 9.24306C27.3083 9.7926 26.8606 10.2381 26.3083 10.2381H10.4902C9.93795 10.2381 9.49023 9.7926 9.49023 9.24306Z",
    fill: "#D8D7E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.05457 32.4266C3.12964 31.8822 3.63406 31.5014 4.18122 31.5761L43.5564 36.9515C43.9594 37.0065 44.3557 36.8131 44.5588 36.4624L64.4001 2.19725C64.6759 1.7211 65.2873 1.5575 65.7658 1.83185C66.2444 2.10619 66.4088 2.71459 66.1331 3.19074L46.2917 37.4559C45.6825 38.508 44.4935 39.0881 43.2845 38.923L3.90936 33.5476C3.3622 33.4729 2.9795 32.971 3.05457 32.4266Z",
    fill: "#D8D7E3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.48567 32.0913C4.4939 32.5751 4.08412 33.7673 4.57039 34.7542L20.7311 67.5501C21.2173 68.5369 22.4155 68.9447 23.4073 68.4608L81.9324 39.9084C82.9242 39.4245 83.334 38.2323 82.8477 37.2455L66.687 4.44954C66.2007 3.46271 65.0025 3.05496 64.0108 3.53882L5.48567 32.0913ZM2.77463 35.6303C1.80208 33.6566 2.62165 31.2722 4.60519 30.3045L63.1303 1.752C65.1138 0.784299 67.5102 1.59978 68.4828 3.57344L84.6434 36.3694C85.616 38.343 84.7964 40.7275 82.8129 41.6952L24.2878 70.2476C22.3042 71.2153 19.9079 70.3999 18.9353 68.4262L2.77463 35.6303Z",
    fill: "#D8D7E3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.24306C0 8.69353 0.447715 8.24805 1 8.24805H4.95452C5.50681 8.24805 5.95452 8.69353 5.95452 9.24306C5.95452 9.7926 5.50681 10.2381 4.95452 10.2381H1C0.447715 10.2381 0 9.7926 0 9.24306Z",
    fill: "#D8D7E3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 33.999,
    r: 12,
    fill: "#EBFBF5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.9304 30.9596L80.2122 40.2215L75.0508 35.06L77.1721 32.9387L80.0106 35.7772L85.6258 29.0391L87.9304 30.9596Z",
    fill: "#22E295"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSent);
export default __webpack_public_path__ + "static/media/email-sent.e6c6d658.svg";
export { ForwardRef as ReactComponent };